import { render, staticRenderFns } from "./TemplatesSearch.vue?vue&type=template&id=4df8cbe8"
import script from "./TemplatesSearch.vue?vue&type=script&lang=js"
export * from "./TemplatesSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports